// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_kr-6";
export var emphasizeQuantity = "_kr-3";
export var flatBottomCorners = "_kr-5";
export var productImage = "_kr-0";
export var quantityContainer = "_kr-2";
export var tooltip = "_kr-1";
export var wrapAndEllipsesOverflow = "_kr-4";